import { render } from "./PowderSavingChart.vue?vue&type=template&id=b3f02892"
import script from "./PowderSavingChart.vue?vue&type=script&lang=js"
export * from "./PowderSavingChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__